export default __webpack_public_path__ + "static/media/Aquanow.0d15150e.png";